module.exports = __webpack_public_path__ + "img/Rectangle 147@2x.1e571325.jpg";